export const getVenues = store => store.venues.venues || []

// Use this Selector for map only. It Excludedes hidden=true venues.
export const getVisibleVenues = store => store.venues.venues?.filter(v => !v.hidden)

// use with hooks: useSelector(getVenueById)(venueId)
export const getVenueById = store => id => store.venues.venues?.find(venue => venue.slug === `${id}`)
export const selectVenueBySlug = slug => store => store.venues.venues?.find(venue => venue.slug === slug)
export const getVenueByIdNew = id => store => store.venues.venues?.find(venue => venue.slug === `${id}`)
